// lettres_data.js — Base pédagogique FirstArabic
// Extraite des supports du prof — méthodologie respectée intégralement

const LETTRES_DATA = {

  // ==================== ي (Ya) ====================
  ya: {
    lettre: 'ي',
    nom: 'الياء',
    transliteration: 'Ya',
    niveau: 'Abjad',
    ordre: 28,
    formes: [
      { forme: 'يـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـيـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـي', position: 'fin', position_ar: 'آخر الكلمة' },
      { forme: 'ي', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [ي] من وسط اللسان مع ما يقابله من وسط الحنك الأعلى',
    situation_depart: {
      texte: 'يَغْسِلُ أيْمَنٌ يَدَيْهِ في الْمِغْسَلِ',
      question: 'ماذا يَفْعَلُ أيْمَنُ؟',
      emoji: '🚿',
      personnage: 'أيْمَنُ'
    },
    mots_exemples: [
      { mot: 'خَيْمَةٌ', mot_highlight: 'خَ<HL>يْ</HL>مَةٌ', fr: 'tente', emoji: '⛺', position: 'milieu' },
      { mot: 'لَيْمونٌ', mot_highlight: 'لَ<HL>يْ</HL>مونٌ', fr: 'citron', emoji: '🍋', position: 'milieu' },
      { mot: 'كُرْسِيٌّ', mot_highlight: 'كُرْسِ<HL>يٌّ</HL>', fr: 'chaise', emoji: '🪑', position: 'fin' },
      { mot: 'دُمْيَةٌ', mot_highlight: 'دُمْ<HL>يَ</HL>ةٌ', fr: 'poupée', emoji: '🪆', position: 'milieu' },
      { mot: 'يَدٌ', mot_highlight: '<HL>يَ</HL>دٌ', fr: 'main', emoji: '🤚', position: 'début' },
      { mot: 'طُيورٌ', mot_highlight: 'طُ<HL>يو</HL>رٌ', fr: 'oiseaux', emoji: '🐦', position: 'milieu' },
    ],
    harakat_courtes: ['يَ', 'يِ', 'يُ'],
    harakat_longues: ['يا', 'يو', 'يي'],
    phrases: [
      { ar: 'يُمْسِكُ يوسُفُ نايًا', fr: 'Youssef tient une flûte', mots_cles: ['يو', 'يً'] },
      { ar: 'يَغـْسِلُ ياسينُ يَدَيْهِ', fr: 'Yassine se lave les mains', mots_cles: ['يَ', 'يا', 'يَ', 'يْ'] },
      { ar: 'يُطْعِمُ أيْمَنُ طُيورًا', fr: 'Ayman nourrit des oiseaux', mots_cles: ['يُ', 'يْ', 'يو'] },
    ],
    exercice_ecriture: {
      phrase: 'يَخيطُ الْخَيّاطُ بِالْمِخْيَطِ',
      fr: 'Le tailleur coud avec l\'aiguille'
    },
    prerequis: [],
  },

  // ==================== ء (Hamza) ====================
  hamza: {
    lettre: 'ء',
    nom: 'الهمزة',
    transliteration: 'Hamza',
    niveau: 'Abjad',
    ordre: 1,
    formes: [
      { forme: 'أ', position: 'début (sur alif)', position_ar: 'أول الكلمة' },
      { forme: 'ـؤ', position: 'milieu (sur waw)', position_ar: 'وسط الكلمة' },
      { forme: 'ـئـ / ئ', position: 'sur ya', position_ar: 'على الياء' },
      { forme: 'ء', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [ء] من تطابق الوترين الصوتيين',
    situation_depart: {
      texte: 'جاءَ أَحْمَدُ مِنَ السَّفَرِ',
      question: 'كيف هو شكله؟ كيف نسميه؟',
      emoji: '✈️',
      personnage: 'أَوْسُ'
    },
    mots_exemples: [
      { mot: 'أَقْلامٌ', mot_highlight: '<HL>أَ</HL>قْلامٌ', fr: 'stylos', emoji: '✏️', position: 'début' },
      { mot: 'رَأْسٌ', mot_highlight: 'رَ<HL>أْ</HL>سٌ', fr: 'tête', emoji: '👤', position: 'milieu' },
      { mot: 'أَسَدٌ', mot_highlight: '<HL>أَ</HL>سَدٌ', fr: 'lion', emoji: '🦁', position: 'début' },
      { mot: 'سَماءٌ', mot_highlight: 'سَما<HL>ءٌ</HL>', fr: 'ciel', emoji: '☁️', position: 'fin' },
      { mot: 'كُؤوسٌ', mot_highlight: 'كُ<HL>ؤ</HL>وسٌ', fr: 'verres', emoji: '🥤', position: 'milieu' },
      { mot: 'هَناءُ', mot_highlight: 'هَنا<HL>ءُ</HL>', fr: 'Hanaa (prénom)', emoji: '👧', position: 'fin' },
      { mot: 'فَأْسٌ', mot_highlight: 'فَ<HL>أْ</HL>سٌ', fr: 'hache', emoji: '🪓', position: 'milieu' },
    ],
    harakat_courtes: ['أَ', 'أِ', 'أُ'],
    harakat_longues: ['أا', 'أو', 'أي'],
    phrases: [
      { ar: 'جاءَ أَحْمَدُ مِنَ السَّفَرِ', fr: 'Ahmed est revenu du voyage', mots_cles: ['جاءَ', 'أَ'] },
    ],
    exercice_ecriture: {
      phrase: 'فَأْسٌ',
      fr: 'une hache'
    },
    prerequis: [],
    note_pedagogique: 'La hamza est unique — elle peut s\'écrire sur plusieurs supports (alif, waw, ya) selon les voyelles qui l\'entourent. Introduire d\'abord la forme sur alif.'
  },

  // ==================== ط (Ta) ====================
  ta_emphatic: {
    lettre: 'ط',
    nom: 'الطاء',
    transliteration: 'Tā (emphatique)',
    niveau: 'Abjad',
    ordre: 16,
    formes: [
      { forme: 'طـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـطـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـط', position: 'fin', position_ar: 'آخر الكلمة' },
      { forme: 'ط', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [ط] من طرف اللسان مع ما يقابله من الحنك الأعلى',
    situation_depart: {
      texte: 'سَأُعِدُّ لَكَ طَبَقًا مِنَ الْبَطاطِسِ وَالطّماطِمِ',
      question: 'ماذا ستُعِدُّ؟',
      emoji: '🍅',
      personnage: 'فاطِمَةُ'
    },
    mots_exemples: [
      { mot: 'قِـطٌّ', mot_highlight: 'قِـ<HL>طٌّ</HL>', fr: 'chat', emoji: '🐱', position: 'fin' },
      { mot: 'طَبْلٌ', mot_highlight: '<HL>طَ</HL>بْلٌ', fr: 'tambour', emoji: '🥁', position: 'début' },
      { mot: 'طُيورٌ', mot_highlight: '<HL>طُ</HL>يورٌ', fr: 'oiseaux', emoji: '🐦', position: 'début' },
      { mot: 'بَطاطِسٌ', mot_highlight: 'بَ<HL>طا</HL>طيسُ', fr: 'pommes de terre', emoji: '🥔', position: 'milieu' },
    ],
    harakat_courtes: ['طَ', 'طِ', 'طُ'],
    harakat_longues: ['طا', 'طو', 'طي'],
    phrases: [
      { ar: 'تُعِدُّ فاطِمَةُ اَلطَّعامَ', fr: 'Fatima prépare le repas', mots_cles: ['الطَّ'] },
    ],
    exercice_ecriture: {
      phrase: 'بَطاطِسٌ',
      fr: 'pommes de terre'
    },
    prerequis: ['ت'],
    note_pedagogique: 'ط est la version emphatique de ت — mettre en évidence la différence sonore avec ت pour les enfants francophones.'
  },

  // ==================== ض (Dad) ====================
  dad: {
    lettre: 'ض',
    nom: 'الضاد',
    transliteration: 'Dād (emphatique)',
    niveau: 'Abjad',
    ordre: 15,
    formes: [
      { forme: 'ضـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـضـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـض', position: 'fin', position_ar: 'آخر الكلمة' },
      { forme: 'ض', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'حرف مُطبَق — يخرج من حافة اللسان اليسرى مع ما يقابلها من الأضراس العليا',
    situation_depart: {
      texte: 'أَحْضَـرْنا بَعْضَ اَلْهَدايا لِوَليد',
      question: 'ماذا أحضرنا؟',
      emoji: '🎁',
      personnage: 'وَليد'
    },
    mots_exemples: [
      { mot: 'مِضْرَبٌ', mot_highlight: 'مِ<HL>ضْ</HL>رَبٌ', fr: 'raquette', emoji: '🏓', position: 'milieu' },
      { mot: 'مَريضٌ', mot_highlight: 'مَري<HL>ضٌ</HL>', fr: 'malade', emoji: '🤒', position: 'fin' },
      { mot: 'رَضيعٌ', mot_highlight: 'رَ<HL>ضي</HL>عٌ', fr: 'bébé', emoji: '👶', position: 'milieu' },
      { mot: 'بَيْضٌ', mot_highlight: 'بَيْ<HL>ضٌ</HL>', fr: 'œufs', emoji: '🥚', position: 'fin' },
    ],
    harakat_courtes: ['ضَ', 'ضِ', 'ضُ'],
    harakat_longues: ['ضا', 'ضو', 'ضي'],
    phrases: [
      { ar: 'أَكَلَ رِضْوانُ بَيْضًا', fr: 'Ridwane a mangé des œufs', mots_cles: ['ضْ', 'ضً'] },
    ],
    exercice_ecriture: {
      phrase: 'بَيْضٌ',
      fr: 'des œufs'
    },
    prerequis: ['د'],
    note_pedagogique: 'ض est réputé la lettre la plus difficile de l\'arabe — la distinguer soigneusement de د et de ظ. L\'arabe est parfois appelé "لغة الضاد" (la langue du Dād).'
  },

  // ==================== ص (Sad) ====================
  sad: {
    lettre: 'ص',
    nom: 'الصاد',
    transliteration: 'Sād (emphatique)',
    niveau: 'Abjad',
    ordre: 14,
    formes: [
      { forme: 'صـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـصـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـص', position: 'fin', position_ar: 'آخر الكلمة' },
      { forme: 'ص', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [ص] من طرف اللسان مع ما فوق الثنايا السفلى',
    situation_depart: {
      texte: 'تُغَذّي الْعُصْفورَةُ عَصافيرَها الصِّغارِ عَلى غُصْنِ شَجَرَةٍ',
      question: 'ما هو الصّوْت المُتَكَرِّر؟',
      emoji: '🐦',
      personnage: 'الصَّيادُ'
    },
    mots_exemples: [
      { mot: 'صَقْرٌ', mot_highlight: '<HL>صَ</HL>قْرٌ', fr: 'faucon', emoji: '🦅', position: 'début' },
      { mot: 'صَـحْنٌ', mot_highlight: '<HL>صَـ</HL>حْنٌ', fr: 'assiette', emoji: '🍽️', position: 'début' },
      { mot: 'صُنْدوقٌ', mot_highlight: '<HL>صُ</HL>نْدوقٌ', fr: 'boîte', emoji: '📦', position: 'début' },
      { mot: 'حِصانٌ', mot_highlight: 'حِ<HL>صا</HL>نٌ', fr: 'cheval', emoji: '🐴', position: 'milieu' },
      { mot: 'بَصَلٌ', mot_highlight: 'بَ<HL>صَ</HL>لٌ', fr: 'oignon', emoji: '🧅', position: 'milieu' },
      { mot: 'مِـقَــصٌّ', mot_highlight: 'مِـقَـ<HL>صٌّ</HL>', fr: 'ciseaux', emoji: '✂️', position: 'fin' },
    ],
    harakat_courtes: ['صَ', 'صِ', 'صُ'],
    harakat_longues: ['صا', 'صو', 'صي'],
    phrases: [
      { ar: 'يَصْطادُ الصَّيادُ السَّمَكَةَ', fr: 'Le pêcheur attrape le poisson', mots_cles: ['يَصْ', 'الصَّ'] },
    ],
    exercice_application: {
      consigne: 'أضع علامة تحت البطاقة المتضمنة لحرف الصاد',
      mots: ['سُلَحْفاةٌ', 'بَـيْـضٌ', 'صوص', 'بَصَلٌ', 'مِـقَــصٌّ'],
      reponses_correctes: ['صوص', 'بَصَلٌ', 'مِـقَــصٌّ']
    },
    exercice_ecriture: { phrase: 'بَصَلٌ', fr: 'oignon' },
    prerequis: ['س'],
    note_pedagogique: 'ص est la version emphatique de س — insister sur la différence avec س pour les enfants francophones.'
  },

  // ==================== ح (Ha) ====================
  ha: {
    lettre: 'ح',
    nom: 'الحاء',
    transliteration: 'Ḥā',
    niveau: 'Abjad',
    ordre: 6,
    formes: [
      { forme: 'حـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـحـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـح', position: 'fin', position_ar: 'آخر الكلمة' },
      { forme: 'ح', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [ح] وسط الحلق دون اعتراض لمجرى الهواء',
    situation_depart: {
      texte: 'تَحْتسي سَماحُ الْحَسْناءُ حَليبًا',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '🥛',
      personnage: 'سَماحُ'
    },
    mots_exemples: [
      { mot: 'حَـمــامَةٌ', mot_highlight: '<HL>حَـ</HL>مامَةٌ', fr: 'pigeon', emoji: '🕊️', position: 'début' },
      { mot: 'حاسوبٌ', mot_highlight: '<HL>حا</HL>سوبٌ', fr: 'ordinateur', emoji: '💻', position: 'début' },
      { mot: 'حَلَزونٌ', mot_highlight: '<HL>حَ</HL>لَزونٌ', fr: 'escargot', emoji: '🐌', position: 'début' },
      { mot: 'مِفْتاحٌ', mot_highlight: 'مِفْتا<HL>حٌ</HL>', fr: 'clé', emoji: '🔑', position: 'fin' },
      { mot: 'حافِلَةٌ', mot_highlight: '<HL>حا</HL>فِلَةٌ', fr: 'bus', emoji: '🚌', position: 'début' },
      { mot: 'بَحْرٌ', mot_highlight: 'بَ<HL>حْ</HL>رٌ', fr: 'mer', emoji: '🌊', position: 'milieu' },
    ],
    harakat_courtes: ['حَ', 'حِ', 'حُ'],
    harakat_longues: ['حا', 'حو', 'حي'],
    phrases: [
      { ar: 'يَجْلِسُ أَحْمَدُ أَمامَ الْبَحْرِ', fr: 'Ahmed est assis devant la mer', mots_cles: ['أَحْ', 'الْبَحْ'] },
    ],
    exercice_ecriture: { phrase: 'بَحْرٌ', fr: 'mer' },
    prerequis: [],
    note_pedagogique: 'ح est un son guttural absent du français — exercer l\'expiration du fond de la gorge sans friction. Ne pas confondre avec خ (avec friction) ni avec ه.'
  },

  // ==================== ج (Jim) ====================
  jim: {
    lettre: 'ج',
    nom: 'الجيم',
    transliteration: 'Jīm',
    niveau: 'Abjad',
    ordre: 5,
    formes: [
      { forme: 'جـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـجـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـج', position: 'fin', position_ar: 'آخر الكلمة' },
      { forme: 'ج', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [ج] من وسط اللسان مع ما يقابله من الحنك الأعلى',
    situation_depart: {
      texte: 'يا خَديـجَـُة يَـِجبُ عَدَمَ الْإحْتِكاكِ أَثْناءَ الْـجَرْيِ',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '🏃',
      personnage: 'جَمالُ'
    },
    mots_exemples: [
      { mot: 'جَمَلٌ', mot_highlight: '<HL>جَ</HL>مَلٌ', fr: 'chameau', emoji: '🐪', position: 'début' },
      { mot: 'جَزَرٌ', mot_highlight: '<HL>جَ</HL>زَرٌ', fr: 'carottes', emoji: '🥕', position: 'début' },
      { mot: 'دَرّاجَةٌ', mot_highlight: 'دَرّا<HL>جَ</HL>ةٌ', fr: 'vélo', emoji: '🚲', position: 'milieu' },
      { mot: 'دَجاجَةُ', mot_highlight: 'دَ<HL>جا</HL>جَةُ', fr: 'poule', emoji: '🐔', position: 'milieu' },
      { mot: 'شَـجرَةٌ', mot_highlight: 'شَـ<HL>جَ</HL>رَةٌ', fr: 'arbre', emoji: '🌳', position: 'milieu' },
      { mot: 'جُنْدِيٌّ', mot_highlight: '<HL>جُ</HL>نْدِيٌّ', fr: 'soldat', emoji: '💂', position: 'début' },
    ],
    harakat_courtes: ['جَ', 'جِ', 'جُ'],
    harakat_longues: ['جا', 'جو', 'جي'],
    decomposition_syllabique: [
      { mot: 'دَجاجٌ', syllabes: ['دَ', 'جا', 'جٌ'], nb: 3 },
      { mot: 'جَمَلٌ', syllabes: ['جَ', 'مَ', 'لٌ'], nb: 3 },
      { mot: 'نُجومٌ', syllabes: ['نُ', 'جو', 'مٌ'], nb: 3 },
    ],
    phrases: [
      { ar: 'يَجْلِسُ جَمالُ أَمامَ الْبَحْرِ', fr: 'Jamal est assis devant la mer', mots_cles: ['يَجْ', 'جَ'] },
    ],
    exercice_ecriture: { phrase: 'نَجّارٌ', fr: 'menuisier' },
    prerequis: [],
    note_pedagogique: 'En arabe standard ج = "dj" (comme dans "djinn"). En Égypte ج se prononce "g" comme dans "gare" — mentionner cette variante dialectale aux enfants.'
  },

  // ==================== ت (Ta) ====================
  ta: {
    lettre: 'ت',
    nom: 'التاء',
    transliteration: 'Tā',
    niveau: 'Abjad',
    ordre: 3,
    formes: [
      { forme: 'تـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـتـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـت / ـة', position: 'fin (+ tā marbūta)', position_ar: 'آخر الكلمة' },
      { forme: 'ت', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [ت] عند التقاء طرف اللسان مع الفك العلوي للأسنان',
    situation_depart: {
      texte: 'اِحْتَرِسْ لا تَتَسَلَّقِ الشُّجَيْراتِ يا فَتى',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '🌳',
      personnage: 'تامِر'
    },
    mots_exemples: [
      { mot: 'تَـمْرٌ', mot_highlight: '<HL>تَـ</HL>مْرٌ', fr: 'dattes', emoji: '🌴', position: 'début' },
      { mot: 'تِلْفازٌ', mot_highlight: '<HL>تِ</HL>لْفازٌ', fr: 'télévision', emoji: '📺', position: 'début' },
      { mot: 'تِمْساحٌ', mot_highlight: '<HL>تِ</HL>مْساحٌ', fr: 'crocodile', emoji: '🐊', position: 'début' },
      { mot: 'تَمْرٌ', mot_highlight: '<HL>تَ</HL>مْرٌ', fr: 'dattes', emoji: '🌴', position: 'début' },
    ],
    harakat_courtes: ['تَ', 'تِ', 'تُ'],
    harakat_longues: ['تا', 'تو', 'تي'],
    ta_marbuta: {
      explication: 'La tā marbūta (ة) est une forme spéciale de ت à la fin des mots féminins',
      exemples: ['مَدْرَسَةٌ (école)', 'حافِلَةٌ (bus)', 'شَجَرَةٌ (arbre)']
    },
    exercice_application: {
      consigne: 'أضع علامة تحت البطاقة المتضمنة لحرف التاء',
      mots: ['مِحْفَطَةٌ', 'تينٌ', 'شَـجَـرَةٌ', 'هاتِفٌ'],
      reponses_correctes: ['تينٌ', 'هاتِفٌ']
    },
    phrases: [
      { ar: 'تـَــجْــلِسُ سَــعــيـــدَةُ مع صَديقَتِها', fr: 'Saïda est assise avec son amie', mots_cles: ['تـَـجْ', 'تِ'] },
    ],
    exercice_ecriture: { phrase: 'تَمْرٌ', fr: 'dattes' },
    prerequis: ['ب'],
    note_pedagogique: 'Point important : introduire la tā marbūta (ة) dès cette leçon — elle apparaît dans presque tous les noms féminins et les enfants la rencontrent immédiatement.'
  },


  // ==================== ش (Shin) ====================
  shin: {
    lettre: 'ش',
    nom: 'الشين',
    transliteration: 'Shīn',
    niveau: 'Abjad',
    ordre: 13,
    formes: [
      { forme: 'شـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـشـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـش', position: 'fin', position_ar: 'آخر الكلمة' },
      { forme: 'ش', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [ش] من بين الحنك واللسان',
    situation_depart: {
      texte: 'اِشْتَرى اَلْأَبُ شُعَيْبُ كَبْشَ العيد',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '🐑',
      personnage: 'شُعَيْبُ'
    },
    mots_exemples: [
      { mot: 'شَجَرَةُ', mot_highlight: '<HL>شَ</HL>جَرَةُ', fr: 'arbre', emoji: '🌳', position: 'début' },
      { mot: 'شَمْسُ', mot_highlight: '<HL>شَ</HL>مْسُ', fr: 'soleil', emoji: '☀️', position: 'début' },
      { mot: 'شِبْلٌ', mot_highlight: '<HL>شِ</HL>بْلٌ', fr: 'lionceau', emoji: '🦁', position: 'début' },
      { mot: 'فَراشَةٌ', mot_highlight: 'فَرا<HL>شَ</HL>ةٌ', fr: 'papillon', emoji: '🦋', position: 'milieu' },
      { mot: 'مِشْمِشٌ', mot_highlight: 'مِ<HL>شْ</HL>مِ<HL>شٌ</HL>', fr: 'abricot', emoji: '🍑', position: 'milieu/fin' },
    ],
    harakat_courtes: ['شَ', 'شِ', 'شُ'],
    harakat_longues: ['شا', 'شو', 'شي'],
    exercice_application: {
      consigne: 'أضع علامة تحت البطاقة المتضمنة لحرف الشين',
      mots: ['ستار', 'شمس', 'مسجد', 'مشمش'],
      reponses_correctes: ['شمس', 'مشمش']
    },
    phrases: [
      { ar: 'اِشْتَرى شُعَيْبُ كَبْشَ العيد', fr: 'Chouaïb a acheté un mouton de l\'Aïd', mots_cles: ['اِشْ', 'شُ', 'كَبْشَ'] },
    ],
    exercice_ecriture: { phrase: 'شَمْسٌ', fr: 'soleil' },
    prerequis: ['س'],
    note_pedagogique: 'ش est proche du "ch" français — son familier pour les enfants francophones. Bon point d\'entrée après س.'
  },

  // ==================== س (Sin) ====================
  sin: {
    lettre: 'س',
    nom: 'السين',
    transliteration: 'Sīn',
    niveau: 'Abjad',
    ordre: 12,
    formes: [
      { forme: 'سـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـسـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـس', position: 'fin', position_ar: 'آخر الكلمة' },
      { forme: 'س', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [س] عند التقاء طرف اللسان مع الفك السفلي للأسنان',
    situation_depart: {
      texte: 'اِلْياسُ سَمِعَ صَفيرَ سَيّارَةِ الْإِسْعافِ قادِمَةً لِإِسْعافِ الْعَمِّ مَسْعود',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '🚑',
      personnage: 'الْياس'
    },
    mots_exemples: [
      { mot: 'سَـمَـكَةٌ', mot_highlight: '<HL>سَـ</HL>مَكَةٌ', fr: 'poisson', emoji: '🐟', position: 'début' },
      { mot: 'سَيّارَةٌ', mot_highlight: '<HL>سَ</HL>يّارَةٌ', fr: 'voiture', emoji: '🚗', position: 'début' },
      { mot: 'سَريرٌ', mot_highlight: '<HL>سَ</HL>ريرٌ', fr: 'lit', emoji: '🛏️', position: 'début' },
      { mot: 'شَـمْسٌ', mot_highlight: 'شَـمْ<HL>سٌ</HL>', fr: 'soleil', emoji: '☀️', position: 'fin' },
      { mot: 'مُسافِرٌ', mot_highlight: 'مُ<HL>سا</HL>فِرٌ', fr: 'voyageur', emoji: '🧳', position: 'milieu' },
      { mot: 'حارِسٌ', mot_highlight: 'حارِ<HL>سٌ</HL>', fr: 'gardien', emoji: '💂', position: 'fin' },
    ],
    harakat_courtes: ['سَ', 'سِ', 'سُ'],
    harakat_longues: ['سا', 'سو', 'سي'],
    exercice_application: {
      consigne: 'أضع علامة تحت البطاقة المتضمنة لحرف السين',
      mots: ['جَــَرٌس', 'كَــأْسٌ', 'شَـجَـرَةٌ', 'مَسْجِدٌ'],
      reponses_correctes: ['جَرَسٌ', 'كَأْسٌ', 'مَسْجِدٌ']
    },
    phrases: [
      { ar: 'تـَــمُـــدُّ سَــعــيـــدَةُ قَـلَـمَـها لـِــسَميرةَ', fr: 'Saïda tend son stylo à Samira', mots_cles: ['سَ', 'سَ'] },
    ],
    exercice_ecriture: { phrase: 'حارِسٌ', fr: 'gardien' },
    prerequis: [],
    note_pedagogique: 'س = "s" comme en français. Introduire ensuite ص (emphatique) et ش pour compléter la famille.'
  },

  // ==================== ز (Zayn) ====================
  zayn: {
    lettre: 'ز',
    nom: 'الزاي',
    transliteration: 'Zayn',
    niveau: 'Abjad',
    ordre: 11,
    formes: [
      { forme: 'زـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـز', position: 'fin/milieu', position_ar: 'وسط/آخر الكلمة' },
      { forme: 'ز', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [ز] بالتقاء طرف اللسان وأسفل الأسنان السفلى',
    situation_depart: {
      texte: 'زَيْنَبُ تَأْكُلُ زَيْتونًا وَمَوْزًا',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '🫒',
      personnage: 'زِرْيابُ'
    },
    mots_exemples: [
      { mot: 'زَيْتونٌ', mot_highlight: '<HL>زَ</HL>يْتونٌ', fr: 'olives', emoji: '🫒', position: 'début' },
      { mot: 'زُبْدَةٌ', mot_highlight: '<HL>زُ</HL>بْدَةٌ', fr: 'beurre', emoji: '🧈', position: 'début' },
      { mot: 'زِرٌّ', mot_highlight: '<HL>زِ</HL>رٌّ', fr: 'bouton', emoji: '🔘', position: 'début' },
      { mot: 'مَوْزٌ', mot_highlight: 'مَوْ<HL>زٌ</HL>', fr: 'banane', emoji: '🍌', position: 'fin' },
      { mot: 'زُهورٌ', mot_highlight: '<HL>زُ</HL>هورٌ', fr: 'fleurs', emoji: '🌸', position: 'début' },
      { mot: 'جَزَرٌ', mot_highlight: 'جَ<HL>زَ</HL>رٌ', fr: 'carottes', emoji: '🥕', position: 'milieu' },
    ],
    harakat_courtes: ['زَ', 'زِ', 'زُ'],
    harakat_longues: ['زا', 'زو', 'زي'],
    decomposition_syllabique: [
      { mot: 'زَيْتونٌ', syllabes: ['زَيْـ', 'ـتو', 'نٌ'], nb: 3 },
      { mot: 'زِرٌّ', syllabes: ['زِرْ', 'رٌ'], nb: 2 },
      { mot: 'زُهورٌ', syllabes: ['زُ', 'هو', 'رٌ'], nb: 3 },
    ],
    phrases: [
      { ar: 'تَاْكُلُ زَيْنَبُ مَوْزاً', fr: 'Zaynab mange une banane', mots_cles: ['زَ', 'مَوْزًا'] },
    ],
    exercice_ecriture: { phrase: 'مَوْزٌ', fr: 'banane' },
    prerequis: ['ر'],
    note_pedagogique: 'ز = "z" comme en français. La lettre ne change pas de forme selon sa position — elle ne se connecte qu\'à droite (comme ر، د، ذ).'
  },

  // ==================== ر (Ra) ====================
  ra: {
    lettre: 'ر',
    nom: 'الراء',
    transliteration: 'Rā',
    niveau: 'Abjad',
    ordre: 10,
    formes: [
      { forme: 'رـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـر', position: 'fin/milieu', position_ar: 'وسط/آخر الكلمة' },
      { forme: 'ر', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [ر] من طرف اللسان مع ما يقابله من الحنك الأعلى',
    situation_depart: {
      texte: 'بِمَدْرَسَتِنا مَكْتَبَةٌ بِها رُفوفٌ وَسَتائِر',
      question: 'ما هُوَ اَلصَّوْتُ اَلْمُتَكَرِّرُ في اَلكَلِماتِ؟',
      emoji: '📚',
      personnage: 'رِياضُ'
    },
    mots_exemples: [
      { mot: 'رُمّانٌ', mot_highlight: '<HL>رُ</HL>مّانٌ', fr: 'grenade', emoji: '🍎', position: 'début' },
      { mot: 'فَـراشَةٌ', mot_highlight: 'فَـ<HL>را</HL>شَةٌ', fr: 'papillon', emoji: '🦋', position: 'milieu' },
      { mot: 'نَـمِـرٌ', mot_highlight: 'نَـمِـ<HL>رٌ</HL>', fr: 'tigre', emoji: '🐯', position: 'fin' },
      { mot: 'ثَــوْرٌ', mot_highlight: 'ثَـوْ<HL>رٌ</HL>', fr: 'taureau', emoji: '🐂', position: 'fin' },
      { mot: 'مَدْرَسَةٌ', mot_highlight: 'مَدْ<HL>رَ</HL>سَةٌ', fr: 'école', emoji: '🏫', position: 'milieu' },
      { mot: 'رِجْلٌ', mot_highlight: '<HL>رِ</HL>جْلٌ', fr: 'pied/jambe', emoji: '🦵', position: 'début' },
    ],
    harakat_courtes: ['رَ', 'رِ', 'رُ'],
    harakat_longues: ['را', 'رو', 'ري'],
    phrases: [
      { ar: 'بِمَدْرَسَتِنا رُفوفٌ وَسَتائِر', fr: 'Notre école a des étagères et des rideaux', mots_cles: ['رَ', 'رُ', 'رَ'] },
    ],
    exercice_ecriture: { phrase: 'مِبْراةٌ', fr: 'taille-crayon' },
    prerequis: ['د'],
    note_pedagogique: 'ر ne se connecte qu\'à droite — comme د، ذ، ز. Le ر arabe est roulé (proche de l\'espagnol), différent du "r" français grasseyé.'
  },

  // ==================== ذ (Dhal) ====================
  dhal: {
    lettre: 'ذ',
    nom: 'الذال',
    transliteration: 'Dhāl',
    niveau: 'Abjad',
    ordre: 9,
    formes: [
      { forme: 'ذـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـذ', position: 'fin/milieu', position_ar: 'وسط/آخر الكلمة' },
      { forme: 'ذ', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [ذ] بالتقاء طرف اللسان و الأسنان العلوية',
    situation_depart: {
      texte: 'تَاْكُلُ ذِكْرى كَعْكًا لَذيذًا',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '🎂',
      personnage: 'مُعاذُ'
    },
    mots_exemples: [
      { mot: 'ذِئْبٌ', mot_highlight: '<HL>ذِ</HL>ئْبٌ', fr: 'loup', emoji: '🐺', position: 'début' },
      { mot: 'ذُبابةٌ', mot_highlight: '<HL>ذُ</HL>بابةٌ', fr: 'mouche', emoji: '🪰', position: 'début' },
      { mot: 'ذَيْلٌ', mot_highlight: '<HL>ذَ</HL>يْلٌ', fr: 'queue', emoji: '🐒', position: 'début' },
      { mot: 'ذُرَةٌ', mot_highlight: '<HL>ذُ</HL>رَةٌ', fr: 'maïs', emoji: '🌽', position: 'début' },
      { mot: 'قُنْفُذٌ', mot_highlight: 'قُنْفُ<HL>ذٌ</HL>', fr: 'hérisson', emoji: '🦔', position: 'fin' },
    ],
    harakat_courtes: ['ذَ', 'ذِ', 'ذُ'],
    harakat_longues: ['ذا', 'ذو', 'ذي'],
    decomposition_syllabique: [
      { mot: 'ذُرَةٌ', syllabes: ['ذُ', 'رَ', 'ةٌ'], nb: 3 },
      { mot: 'ذِكْرٌ', syllabes: ['ذِكْ', 'رٌ'], nb: 2 },
      { mot: 'قُنْفُذٌ', syllabes: ['قُنْ', 'فُ', 'ذٌ'], nb: 3 },
    ],
    phrases: [
      { ar: 'تَاْكُلُ ذِكْرى كَعْكًا لَذيذًا', fr: 'Dhikra mange un délicieux gâteau', mots_cles: ['ذِ', 'لَذيذًا'] },
    ],
    exercice_ecriture: { phrase: 'ذُرَةٌ', fr: 'maïs' },
    prerequis: ['د'],
    note_pedagogique: 'ذ = "th" sonore anglais (comme "the", "this"). Son absent du français — exercer la langue entre les dents. Ne pas confondre avec د (sans langue entre les dents).'
  },

  // ==================== د (Dal) ====================
  dal: {
    lettre: 'د',
    nom: 'الدال',
    transliteration: 'Dāl',
    niveau: 'Abjad',
    ordre: 8,
    formes: [
      { forme: 'دـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـد', position: 'fin/milieu', position_ar: 'وسط/آخر الكلمة' },
      { forme: 'د', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [د] عند التقاء طرف اللسان مع الفك العلوي للأسنان',
    situation_depart: {
      texte: 'يَتَوَجَّهُ أَحْمَدُ وَمُحَمَّدُ وَوِدادُ وَوَليدُ إِلى اَلْمَدْرَسَةِ',
      question: 'ما هُوَ اَلصَّوْتُ اَلْمُتَكَرِّرُ في اَلكَلِماتِ؟',
      emoji: '🏫',
      personnage: 'بَدْرُ'
    },
    mots_exemples: [
      { mot: 'دِماغٌ', mot_highlight: '<HL>دِ</HL>ماغٌ', fr: 'cerveau', emoji: '🧠', position: 'début' },
      { mot: 'دُبٌّ', mot_highlight: '<HL>دُ</HL>بٌّ', fr: 'ours', emoji: '🐻', position: 'début' },
      { mot: 'دَجاجٌ', mot_highlight: '<HL>دَ</HL>جاجٌ', fr: 'poulet', emoji: '🐔', position: 'début' },
      { mot: 'وَرْدَةٌ', mot_highlight: 'وَرْ<HL>دَ</HL>ةٌ', fr: 'rose', emoji: '🌹', position: 'milieu' },
      { mot: 'مَدينَةٌ', mot_highlight: 'مَ<HL>دي</HL>نَةٌ', fr: 'ville', emoji: '🏙️', position: 'milieu' },
      { mot: 'دَلْوٌ', mot_highlight: '<HL>دَ</HL>لْوٌ', fr: 'seau', emoji: '🪣', position: 'début' },
    ],
    harakat_courtes: ['دَ', 'دِ', 'دُ'],
    harakat_longues: ['دا', 'دو', 'دي'],
    phrases: [
      { ar: 'تَقْطُنُ خَديجَةُ بِالْمَدينَةِ', fr: 'Khadija habite en ville', mots_cles: ['دَ', 'الْمَدِ'] },
      { ar: 'تـَــمُـــدُّ سَعيدَةُ قَلَمَها لِهِنْدَ', fr: 'Saïda tend son stylo à Hind', mots_cles: ['دُّ', 'دَ'] },
    ],
    exercice_ecriture: { phrase: 'دودَةٌ', fr: 'ver de terre' },
    prerequis: [],
    note_pedagogique: 'د ne se connecte qu\'à droite — lettre "non-connectante" à gauche. Introduire ذ immédiatement après pour montrer la paire د/ذ.'
  },


  // ==================== خ (Kha) ====================
  kha: {
    lettre: 'خ',
    nom: 'الخاء',
    transliteration: 'Khā',
    niveau: 'Abjad',
    ordre: 7,
    formes: [
      { forme: 'خـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـخـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـخ', position: 'fin', position_ar: 'آخر الكلمة' },
      { forme: 'خ', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [خ] من أدنى الحلق عندما يلتصق مؤخرة الحنك',
    situation_depart: {
      texte: 'زارَتْ خَوْلَةُ وَابْنَيْها خَديجَةُ وَخالِدُ أَخاها',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '🏠',
      personnage: 'خالدُ'
    },
    mots_exemples: [
      { mot: 'خوخٌ', mot_highlight: '<HL>خو</HL>خٌ', fr: 'pêche', emoji: '🍑', position: 'début' },
      { mot: 'خَروفٌ', mot_highlight: '<HL>خَ</HL>روفٌ', fr: 'mouton', emoji: '🐑', position: 'début' },
      { mot: 'نَخْلَةٌ', mot_highlight: 'نَ<HL>خْ</HL>لَةٌ', fr: 'palmier', emoji: '🌴', position: 'milieu' },
      { mot: 'خَيْطٌ', mot_highlight: '<HL>خَ</HL>يْطٌ', fr: 'fil', emoji: '🧵', position: 'début' },
      { mot: 'خُبْزٌ', mot_highlight: '<HL>خُ</HL>بْزٌ', fr: 'pain', emoji: '🍞', position: 'début' },
    ],
    harakat_courtes: ['خَ', 'خِ', 'خُ'],
    harakat_longues: ['خا', 'خو', 'خي'],
    phrases: [
      { ar: 'أَكَلَتْ خَديجَةُ خوخاً', fr: 'Khadija a mangé une pêche', mots_cles: ['خَ', 'خو'] },
    ],
    exercice_ecriture: { phrase: 'خالدُ', fr: 'Khaled (prénom)' },
    prerequis: ['ح', 'ج'],
    note_pedagogique: 'خ = "kh" comme en espagnol "jota" ou le "ch" allemand dans "Bach". À distinguer soigneusement de ح (sans friction). La paire ح/خ est fondamentale.'
  },

  // ==================== ث (Tha) ====================
  tha: {
    lettre: 'ث',
    nom: 'الثاء',
    transliteration: 'Thā',
    niveau: 'Abjad',
    ordre: 4,
    formes: [
      { forme: 'ثـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـثـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـث', position: 'fin', position_ar: 'آخر الكلمة' },
      { forme: 'ث', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [ث] من التقاء أسلة اللسان مع الأسنان العلوية',
    situation_depart: {
      texte: 'جَلَسَتْ أُسْرَةُ عُثْمانَ وَثَراءَ تَحْتَ اَلثُّـرَيّا',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '⭐',
      personnage: 'عُثْمانُ'
    },
    mots_exemples: [
      { mot: 'ثَعْلَبٌ', mot_highlight: '<HL>ثَ</HL>عْلَبٌ', fr: 'renard', emoji: '🦊', position: 'début' },
      { mot: 'ثَوْرٌ', mot_highlight: '<HL>ثَ</HL>وْرٌ', fr: 'taureau', emoji: '🐂', position: 'début' },
      { mot: 'ثَلاثَةٌ', mot_highlight: '<HL>ثَ</HL>لا<HL>ثَ</HL>ةٌ', fr: 'trois', emoji: '3️⃣', position: 'début' },
      { mot: 'ثَمانِيَةٌ', mot_highlight: '<HL>ثَ</HL>مانِيَةٌ', fr: 'huit', emoji: '8️⃣', position: 'début' },
      { mot: 'ثُعْبانٌ', mot_highlight: '<HL>ثُ</HL>عْبانٌ', fr: 'serpent', emoji: '🐍', position: 'début' },
      { mot: 'ثَلاجَةٌ', mot_highlight: '<HL>ثَ</HL>لاجَةٌ', fr: 'réfrigérateur', emoji: '🧊', position: 'début' },
    ],
    harakat_courtes: ['ثَ', 'ثِ', 'ثُ'],
    harakat_longues: ['ثا', 'ثو', 'ثي'],
    phrases: [
      { ar: 'ارْتَدَتْ ثَراءُ ثِيابًا أَنيقًا', fr: 'Tharaa a mis de beaux vêtements', mots_cles: ['ثَ', 'ثِ'] },
      { ar: 'بِمَنْزِلِنا أَثاثٌ جَميلٌ', fr: 'Notre maison a de beaux meubles', mots_cles: ['أَثا'] },
    ],
    exercice_ecriture: { phrase: 'ثَلاجَةٌ', fr: 'réfrigérateur' },
    prerequis: ['ت', 'ب'],
    note_pedagogique: 'ث = "th" sourd anglais (comme "think", "three"). Absent du français — langue entre les dents mais sans vibration (contrairement à ذ qui est sonore). Utiliser les chiffres ثَلاثَةٌ (3) et ثَمانِيَةٌ (8) comme ancrage mémoriel.'
  },

  // ==================== ظ (Dha emphatique) ====================
  dha: {
    lettre: 'ظ',
    nom: 'الظاء',
    transliteration: 'Dhā (emphatique)',
    niveau: 'Abjad',
    ordre: 17,
    formes: [
      { forme: 'ظـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـظـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـظ', position: 'fin', position_ar: 'آخر الكلمة' },
      { forme: 'ظ', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [ظ] من التقاء أسلة اللسان مع الأسنان العلوية',
    situation_depart: {
      texte: 'ظَلَّ ظافِرُ وظاهِرُ يَلْعَبانِ اَلْكُرَةَ تَحْتَ ظِلالِ اَلشَّجَرِ',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '⛹️',
      personnage: 'ظافِرُ'
    },
    mots_exemples: [
      { mot: 'أَظافِرٌ', mot_highlight: 'أَ<HL>ظا</HL>فِرٌ', fr: 'ongles', emoji: '💅', position: 'milieu' },
      { mot: 'مِنْظارٌ', mot_highlight: 'مِنْ<HL>ظا</HL>رٌ', fr: 'télescope', emoji: '🔭', position: 'milieu' },
      { mot: 'نَظّارَةٌ', mot_highlight: 'نَ<HL>ظّا</HL>رَةٌ', fr: 'lunettes', emoji: '👓', position: 'milieu' },
      { mot: 'مِحْفَظَةٌ', mot_highlight: 'مِحْفَ<HL>ظَ</HL>ةٌ', fr: 'cartable', emoji: '🎒', position: 'milieu' },
      { mot: 'مِظَلَّةٌ', mot_highlight: 'مِ<HL>ظَ</HL>لَّةٌ', fr: 'parapluie', emoji: '☂️', position: 'milieu' },
    ],
    harakat_courtes: ['ظَ', 'ظِ', 'ظُ'],
    harakat_longues: ['ظا', 'ظو', 'ظي'],
    phrases: [
      { ar: 'ظافِرُ يَحْمِلُ مِحْفَظَتَهُ', fr: 'Dhafir porte son cartable', mots_cles: ['ظا', 'ظَ'] },
      { ar: 'ظَلَّ ظافِرُ يَلْعَبُ تَحْتَ ظِلالِ الشَّجَرِ', fr: 'Dhafir a joué à l\'ombre des arbres', mots_cles: ['ظَ', 'ظا', 'ظِ'] },
    ],
    exercice_ecriture: { phrase: 'مِظَلَّةٌ', fr: 'parapluie' },
    prerequis: ['ذ', 'ض'],
    note_pedagogique: 'ظ est la version emphatique de ذ — même position de langue entre les dents mais avec emphase (langue plus tendue). La lettre la plus rare en arabe. Quadruplet difficile à maîtriser : ذ/ظ/ض/ز — les distinguer progressivement.'
  },

  // ==================== و (Waw) ====================
  waw: {
    lettre: 'و',
    nom: 'الواو',
    transliteration: 'Wāw',
    niveau: 'Abjad',
    ordre: 27,
    formes: [
      { forme: 'وـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـو', position: 'fin/milieu', position_ar: 'وسط/آخر الكلمة' },
      { forme: 'و', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [و] من الشفتين مع تضييق مجرى الهواء',
    situation_depart: {
      texte: 'مَنْزِلُنا واسِعٌ وَمُزَيَّنٌ',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '🏠',
      personnage: 'وَليدُ'
    },
    mots_exemples: [
      { mot: 'وَزَّةٌ', mot_highlight: '<HL>وَ</HL>زَّةٌ', fr: 'oie', emoji: '🦢', position: 'début' },
      { mot: 'وَرْدَةٌ', mot_highlight: '<HL>وَ</HL>رْدَةٌ', fr: 'rose', emoji: '🌹', position: 'début' },
      { mot: 'دودَةٌ', mot_highlight: 'دو<HL>دَ</HL>ةٌ', fr: 'ver de terre', emoji: '🐛', position: 'milieu' },
      { mot: 'نَوْمٌ', mot_highlight: 'نَ<HL>وْ</HL>مٌ', fr: 'sommeil', emoji: '😴', position: 'milieu' },
      { mot: 'مَوْزٌ', mot_highlight: 'مَ<HL>وْ</HL>زٌ', fr: 'banane', emoji: '🍌', position: 'milieu' },
    ],
    harakat_courtes: ['وَ', 'وِ', 'وُ'],
    harakat_longues: ['وا', 'وو', 'وي'],
    phrases: [
      { ar: 'مَنْزِلُنا واسِعٌ وَمُزَيَّنٌ', fr: 'Notre maison est grande et décorée', mots_cles: ['وا', 'وَ'] },
    ],
    exercice_ecriture: { phrase: 'وَزَّةٌ', fr: 'oie' },
    prerequis: [],
    note_pedagogique: 'و joue deux rôles : consonne (comme "w" anglais) et voyelle longue ū. C\'est aussi la lettre de coordination "et" en arabe. Ne se connecte qu\'à droite.'
  },

  // ==================== ه (Ha) ====================
  ha_light: {
    lettre: 'ه',
    nom: 'الهاء',
    transliteration: 'Hā',
    niveau: 'Abjad',
    ordre: 26,
    formes: [
      { forme: 'هـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـهـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـه', position: 'fin', position_ar: 'آخر الكلمة' },
      { forme: 'ه', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [ه] من أقصى الحلق — نفس خفيف بدون احتكاك',
    situation_depart: {
      texte: 'ضَرَبَ ضِياءُ اَلْكُرَةَ بِاَلْمِضْرَبِ',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '🏓',
      personnage: 'هِنْدُ'
    },
    mots_exemples: [
      { mot: 'هِرٌّ', mot_highlight: '<HL>هِ</HL>رٌّ', fr: 'chat', emoji: '🐱', position: 'début' },
      { mot: 'مُهَبِّهٌ', mot_highlight: 'مُ<HL>هَ</HL>بِّ<HL>هٌ</HL>', fr: 'ventilateur', emoji: '🌀', position: 'milieu/fin' },
      { mot: 'هِلالٌ', mot_highlight: '<HL>هِ</HL>لالٌ', fr: 'croissant de lune', emoji: '🌙', position: 'début' },
      { mot: 'نَهَرٌ', mot_highlight: 'نَ<HL>هَ</HL>رٌ', fr: 'rivière', emoji: '🏞️', position: 'milieu' },
      { mot: 'وَجْهٌ', mot_highlight: 'وَجْ<HL>هٌ</HL>', fr: 'visage', emoji: '😊', position: 'fin' },
    ],
    harakat_courtes: ['هَ', 'هِ', 'هُ'],
    harakat_longues: ['ها', 'هو', 'هي'],
    phrases: [
      { ar: 'ضَرَبَ ضِياءُ الكُرَةَ بِالْمِضْرَبِ', fr: 'Dhiaa a frappé la balle avec la raquette', mots_cles: ['ضَ', 'ضِ', 'ضْ'] },
    ],
    exercice_ecriture: { phrase: 'هِرٌّ', fr: 'chat' },
    prerequis: ['ح'],
    note_pedagogique: 'ه est plus léger que ح — simple aspiration sans friction. Distinction fondamentale : ه (souffle léger) vs ح (friction gutturale). La tā marbūta ة est une variante de ه en fin de mot.'
  },

  // ==================== ع (Ayn) ====================
  ayn: {
    lettre: 'ع',
    nom: 'العين',
    transliteration: 'ʿAyn',
    niveau: 'Abjad',
    ordre: 18,
    formes: [
      { forme: 'عـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـعـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـع', position: 'fin', position_ar: 'آخر الكلمة' },
      { forme: 'ع', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [ع] من وسط الحلق مع ضغط على مجرى الهواء',
    situation_depart: {
      texte: 'الطَّبيعَةُ جَميلَةٌ',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '🌿',
      personnage: 'عَلِيُّ'
    },
    mots_exemples: [
      { mot: 'عِنَبٌ', mot_highlight: '<HL>عِ</HL>نَبٌ', fr: 'raisins', emoji: '🍇', position: 'début' },
      { mot: 'مَلْعَبٌ', mot_highlight: 'مَلْ<HL>عَ</HL>بٌ', fr: 'terrain de jeu', emoji: '⚽', position: 'milieu' },
      { mot: 'عَيْنٌ', mot_highlight: '<HL>عَ</HL>يْنٌ', fr: 'œil/source', emoji: '👁️', position: 'début' },
      { mot: 'أَسَدٌ', mot_highlight: '<HL>عَ</HL>سَلٌ', fr: 'miel', emoji: '🍯', position: 'début' },
      { mot: 'رَبيعٌ', mot_highlight: 'رَبِ<HL>يعٌ</HL>', fr: 'printemps', emoji: '🌸', position: 'fin' },
    ],
    harakat_courtes: ['عَ', 'عِ', 'عُ'],
    harakat_longues: ['عا', 'عو', 'عي'],
    phrases: [
      { ar: 'الطَّبيعَةُ جَميلَةٌ', fr: 'La nature est belle', mots_cles: ['طَبيعَ'] },
    ],
    exercice_ecriture: { phrase: 'عِنَبٌ', fr: 'raisins' },
    prerequis: [],
    note_pedagogique: 'ع est le son le plus difficile pour les francophones — contraction du fond de la gorge sans équivalent en français. S\'entraîner à partir d\'un "a" profond avec constriction pharyngée. Ne pas confondre avec ء (hamza) ni avec غ.'
  },

  // ==================== غ (Ghayn) ====================
  ghayn: {
    lettre: 'غ',
    nom: 'الغين',
    transliteration: 'Ghayn',
    niveau: 'Abjad',
    ordre: 19,
    formes: [
      { forme: 'غـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـغـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـغ', position: 'fin', position_ar: 'آخر الكلمة' },
      { forme: 'غ', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [غ] من أدنى الحلق مع احتكاك — كالغرغرة',
    situation_depart: {
      texte: 'تُغَذّي الْعُصْفورَةُ عَصافيرَها الصِّغارِ',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '🐦',
      personnage: 'غَسّانُ'
    },
    mots_exemples: [
      { mot: 'غُرابٌ', mot_highlight: '<HL>غُ</HL>رابٌ', fr: 'corbeau', emoji: '🐦‍⬛', position: 'début' },
      { mot: 'غَنَمٌ', mot_highlight: '<HL>غَ</HL>نَمٌ', fr: 'moutons', emoji: '🐑', position: 'début' },
      { mot: 'مُغَنٍّ', mot_highlight: 'مُ<HL>غَ</HL>نٍّ', fr: 'chanteur', emoji: '🎤', position: 'milieu' },
      { mot: 'صَغيرٌ', mot_highlight: 'صَ<HL>غي</HL>رٌ', fr: 'petit', emoji: '🐣', position: 'milieu' },
      { mot: 'دِماغٌ', mot_highlight: 'دِما<HL>غٌ</HL>', fr: 'cerveau', emoji: '🧠', position: 'fin' },
    ],
    harakat_courtes: ['غَ', 'غِ', 'غُ'],
    harakat_longues: ['غا', 'غو', 'غي'],
    phrases: [
      { ar: 'الطَّبيعَةُ جَميلَةٌ وَغَنِيَّةٌ', fr: 'La nature est belle et riche', mots_cles: ['غَ'] },
    ],
    exercice_ecriture: { phrase: 'غُرابٌ', fr: 'corbeau' },
    prerequis: ['ع', 'خ'],
    note_pedagogique: 'غ = version sonore de خ, proche du "r" parisien grasseyé. C\'est la paire غ/خ comme ع/ح. Les enfants parisiens reconnaissent souvent ce son instinctivement.'
  },

  // ==================== ف (Fa) ====================
  fa: {
    lettre: 'ف',
    nom: 'الفاء',
    transliteration: 'Fā',
    niveau: 'Abjad',
    ordre: 20,
    formes: [
      { forme: 'فـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـفـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـف', position: 'fin', position_ar: 'آخر الكلمة' },
      { forme: 'ف', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [ف] من احتكاك الشفة السفلى مع الأسنان العلوية',
    situation_depart: {
      texte: 'تـَــمُـــدُّ سَعيدَةُ قَلَمَها لِسَميرةَ',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '✏️',
      personnage: 'فاطِمَةُ'
    },
    mots_exemples: [
      { mot: 'فَراشَةٌ', mot_highlight: '<HL>فَ</HL>راشَةٌ', fr: 'papillon', emoji: '🦋', position: 'début' },
      { mot: 'فِيلٌ', mot_highlight: '<HL>فِ</HL>يلٌ', fr: 'éléphant', emoji: '🐘', position: 'début' },
      { mot: 'قَلَمٌ', mot_highlight: 'قَلَ<HL>مٌ</HL>', fr: 'stylo', emoji: '✏️', position: 'fin' },
      { mot: 'حافِلَةٌ', mot_highlight: 'حا<HL>فِ</HL>لَةٌ', fr: 'bus', emoji: '🚌', position: 'milieu' },
      { mot: 'طَرَفٌ', mot_highlight: 'طَرَ<HL>فٌ</HL>', fr: 'bout/extrémité', emoji: '📍', position: 'fin' },
    ],
    harakat_courtes: ['فَ', 'فِ', 'فُ'],
    harakat_longues: ['فا', 'فو', 'في'],
    phrases: [
      { ar: 'تَجْلِسُ صَفاءُ في الْمَكْتَبَةِ', fr: 'Safaa est assise à la bibliothèque', mots_cles: ['صَ', 'فا'] },
    ],
    exercice_ecriture: { phrase: 'فَراشَةٌ', fr: 'papillon' },
    prerequis: [],
    note_pedagogique: 'ف = "f" comme en français — son familier. Lettre facile d\'accès pour les enfants francophones.'
  },

  // ==================== ق (Qaf) ====================
  qaf: {
    lettre: 'ق',
    nom: 'القاف',
    transliteration: 'Qāf',
    niveau: 'Abjad',
    ordre: 21,
    formes: [
      { forme: 'قـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـقـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـق', position: 'fin', position_ar: 'آخر الكلمة' },
      { forme: 'ق', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [ق] من أقصى اللسان مع ما يقابله من أقصى الحنك',
    situation_depart: {
      texte: 'قامَ قاسَمُ بِنُزْهَةٍ في الطَّبيعَةِ',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '🌿',
      personnage: 'قاسَمُ'
    },
    mots_exemples: [
      { mot: 'قَلَمٌ', mot_highlight: '<HL>قَ</HL>لَمٌ', fr: 'stylo', emoji: '✏️', position: 'début' },
      { mot: 'قِطٌّ', mot_highlight: '<HL>قِ</HL>طٌّ', fr: 'chat', emoji: '🐱', position: 'début' },
      { mot: 'طائِرٌ', mot_highlight: 'طا<HL>ئِ</HL>رٌ', fr: 'oiseau', emoji: '🐦', position: 'milieu' },
      { mot: 'سُوقٌ', mot_highlight: 'سُو<HL>قٌ</HL>', fr: 'marché', emoji: '🛒', position: 'fin' },
      { mot: 'قَمَرٌ', mot_highlight: '<HL>قَ</HL>مَرٌ', fr: 'lune', emoji: '🌙', position: 'début' },
    ],
    harakat_courtes: ['قَ', 'قِ', 'قُ'],
    harakat_longues: ['قا', 'قو', 'قي'],
    phrases: [
      { ar: 'قامَ قاسَمُ بِنُزْهَةٍ في الطَّبيعَةِ', fr: 'Qassem a fait une promenade dans la nature', mots_cles: ['قا', 'قا'] },
    ],
    exercice_ecriture: { phrase: 'قَمَرٌ', fr: 'lune' },
    prerequis: ['ك'],
    note_pedagogique: 'ق est produit plus en arrière que ك — du fond de la gorge. Son absent du français. À distinguer de ك (plus en avant) et de غ/خ (qui ont de la friction).'
  },

  // ==================== ك (Kaf) ====================
  kaf: {
    lettre: 'ك',
    nom: 'الكاف',
    transliteration: 'Kāf',
    niveau: 'Abjad',
    ordre: 22,
    formes: [
      { forme: 'كـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـكـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـك', position: 'fin', position_ar: 'آخر الكلمة' },
      { forme: 'ك', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [ك] من مؤخرة اللسان مع الحنك الأعلى',
    situation_depart: {
      texte: 'يَلْعَبُ التَّلاميذُ في اَلْمَلْعَبِ',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '⚽',
      personnage: 'كَريمُ'
    },
    mots_exemples: [
      { mot: 'كُرَةٌ', mot_highlight: '<HL>كُ</HL>رَةٌ', fr: 'balle', emoji: '⚽', position: 'début' },
      { mot: 'بِكْرٌ', mot_highlight: 'بِ<HL>كْ</HL>رٌ', fr: 'premier-né', emoji: '👶', position: 'milieu' },
      { mot: 'مَلْعَبٌ', mot_highlight: 'مَلْعَ<HL>بٌ</HL>', fr: 'terrain de jeu', emoji: '🏟️', position: 'fin' },
      { mot: 'كِتابٌ', mot_highlight: '<HL>كِ</HL>تابٌ', fr: 'livre', emoji: '📖', position: 'début' },
      { mot: 'سَمَكٌ', mot_highlight: 'سَمَ<HL>كٌ</HL>', fr: 'poisson', emoji: '🐟', position: 'fin' },
    ],
    harakat_courtes: ['كَ', 'كِ', 'كُ'],
    harakat_longues: ['كا', 'كو', 'كي'],
    decomposition_syllabique: [
      { mot: 'كُرَةٌ', syllabes: ['كُ', 'رَ', 'ةٌ'], nb: 3 },
      { mot: 'بِكْرٌ', syllabes: ['بِكْ', 'رٌ'], nb: 2 },
      { mot: 'يَنْبوعٌ', syllabes: ['يَنْ', 'بو', 'عٌ'], nb: 3 },
    ],
    phrases: [
      { ar: 'يَلْعَبُ التَّلاميذُ في اَلْمَلْعَبِ', fr: 'Les élèves jouent sur le terrain', mots_cles: ['كَ', 'كِ'] },
      { ar: 'مَنْزِلُنا مُرَتَّبٌ', fr: 'Notre maison est rangée', mots_cles: ['كَ'] },
    ],
    exercice_ecriture: { phrase: 'كِتابٌ', fr: 'livre' },
    prerequis: [],
    note_pedagogique: 'ك = "k" comme en français. Son familier. Introduire ق après pour montrer la différence de position d\'articulation.'
  },

  // ==================== ل (Lam) ====================
  lam: {
    lettre: 'ل',
    nom: 'اللام',
    transliteration: 'Lām',
    niveau: 'Abjad',
    ordre: 23,
    formes: [
      { forme: 'لـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـلـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـل', position: 'fin', position_ar: 'آخر الكلمة' },
      { forme: 'ل', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [ل] من طرف اللسان مع الحنك الأعلى مع انحراف الهواء',
    situation_depart: {
      texte: 'مَنْزِلُنا مُرَتَّبٌ',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '🏠',
      personnage: 'لَيْلى'
    },
    mots_exemples: [
      { mot: 'رَمْلٌ', mot_highlight: 'رَمْ<HL>لٌ</HL>', fr: 'sable', emoji: '🏖️', position: 'fin' },
      { mot: 'لَيْمونٌ', mot_highlight: '<HL>لَ</HL>يْمونٌ', fr: 'citron', emoji: '🍋', position: 'début' },
      { mot: 'مَلْعَبٌ', mot_highlight: 'مَ<HL>لْ</HL>عَبٌ', fr: 'terrain de jeu', emoji: '⚽', position: 'milieu' },
      { mot: 'جَمَلٌ', mot_highlight: 'جَمَ<HL>لٌ</HL>', fr: 'chameau', emoji: '🐪', position: 'fin' },
      { mot: 'لِسانٌ', mot_highlight: '<HL>لِ</HL>سانٌ', fr: 'langue', emoji: '👅', position: 'début' },
    ],
    harakat_courtes: ['لَ', 'لِ', 'لُ'],
    harakat_longues: ['لا', 'لو', 'لي'],
    phrases: [
      { ar: 'مَنْزِلُنا مُرَتَّبٌ', fr: 'Notre maison est rangée', mots_cles: ['لُ', 'لَ'] },
    ],
    exercice_ecriture: { phrase: 'رَمْلٌ', fr: 'sable' },
    prerequis: [],
    note_pedagogique: 'ل = "l" comme en français. Attention à la combinaison ال (article défini) où ل peut s\'assimiler avec la lettre suivante (lettres solaires) — point crucial en arabe.'
  },

  // ==================== م (Mim) ====================
  mim: {
    lettre: 'م',
    nom: 'الميم',
    transliteration: 'Mīm',
    niveau: 'Abjad',
    ordre: 24,
    formes: [
      { forme: 'مـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـمـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـم', position: 'fin', position_ar: 'آخر الكلمة' },
      { forme: 'م', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [م] من انطباق الشفتين مع خروج الهواء من الأنف',
    situation_depart: {
      texte: 'مَدْرَسَتُنا جَديدَةٌ',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '🏫',
      personnage: 'مَرْيَمُ'
    },
    mots_exemples: [
      { mot: 'مِخَدَّةٌ', mot_highlight: '<HL>مِ</HL>خَدَّةٌ', fr: 'oreiller', emoji: '🛏️', position: 'début' },
      { mot: 'دُمْيَةٌ', mot_highlight: 'دُ<HL>مْ</HL>يَةٌ', fr: 'poupée', emoji: '🪆', position: 'milieu' },
      { mot: 'مِدادٌ', mot_highlight: '<HL>مِ</HL>دادٌ', fr: 'encre', emoji: '🖊️', position: 'début' },
      { mot: 'مَدْرَسَةٌ', mot_highlight: '<HL>مَ</HL>دْرَسَةٌ', fr: 'école', emoji: '🏫', position: 'début' },
      { mot: 'مُدَرِّسٌ', mot_highlight: '<HL>مُ</HL>دَرِّسٌ', fr: 'professeur', emoji: '👨‍🏫', position: 'début' },
    ],
    harakat_courtes: ['مَ', 'مِ', 'مُ'],
    harakat_longues: ['ما', 'مو', 'مي'],
    phrases: [
      { ar: 'مَدْرَسَتُنا جَديدَةٌ', fr: 'Notre école est nouvelle', mots_cles: ['مَ', 'مُ'] },
      { ar: 'أَنْجَزَتْ مَرْيَمُ واجِبَها الْمَنْزِلِيَّ', fr: 'Maryam a fait ses devoirs à la maison', mots_cles: ['مَ', 'مَ'] },
    ],
    exercice_ecriture: { phrase: 'دُمْيَةٌ', fr: 'poupée' },
    prerequis: [],
    note_pedagogique: 'م = "m" comme en français. Son très familier. Première lettre de مُحَمَّد et مَرْيَم — prénoms connus des enfants MRE.'
  },

  // ==================== ن (Nun) ====================
  nun: {
    lettre: 'ن',
    nom: 'النون',
    transliteration: 'Nūn',
    niveau: 'Abjad',
    ordre: 25,
    formes: [
      { forme: 'نـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـنـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـن', position: 'fin', position_ar: 'آخر الكلمة' },
      { forme: 'ن', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [ن] من طرف اللسان مع الحنك الأعلى مع خروج الهواء من الأنف',
    situation_depart: {
      texte: 'نَسْكُنُ في مَنْزِلٍ جَميلٍ',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '🏡',
      personnage: 'نُورُ'
    },
    mots_exemples: [
      { mot: 'نَحْلَةٌ', mot_highlight: '<HL>نَ</HL>حْلَةٌ', fr: 'abeille', emoji: '🐝', position: 'début' },
      { mot: 'نَعْناعٌ', mot_highlight: '<HL>نَ</HL>عْ<HL>نا</HL>عٌ', fr: 'menthe', emoji: '🌿', position: 'début' },
      { mot: 'سَنَدٌ', mot_highlight: 'سَ<HL>نَ</HL>دٌ', fr: 'appui/support', emoji: '🤝', position: 'milieu' },
      { mot: 'مَنْزِلٌ', mot_highlight: 'مَ<HL>نْ</HL>زِلٌ', fr: 'maison', emoji: '🏠', position: 'milieu' },
      { mot: 'سِكّينٌ', mot_highlight: 'سِكّي<HL>نٌ</HL>', fr: 'couteau', emoji: '🔪', position: 'fin' },
    ],
    harakat_courtes: ['نَ', 'نِ', 'نُ'],
    harakat_longues: ['نا', 'نو', 'ني'],
    phrases: [
      { ar: 'نَسْكُنُ في مَنْزِلٍ جَميلٍ', fr: 'Nous habitons dans une belle maison', mots_cles: ['نَ', 'نُ', 'مَنْ'] },
      { ar: 'النَّحْلَةُ تُعْطينا الْعَسَلَ', fr: 'L\'abeille nous donne du miel', mots_cles: ['نَ', 'نا'] },
    ],
    exercice_ecriture: { phrase: 'نَحْلَةٌ', fr: 'abeille' },
    prerequis: [],
    note_pedagogique: 'ن = "n" comme en français. Attention au tanwin (ً ٍ ٌ) qui ajoute un "n" à la fin des mots indéfinis — point grammatical à introduire progressivement.'
  },

  // ==================== ب (Ba) ====================
  ba: {
    lettre: 'ب',
    nom: 'الباء',
    transliteration: 'Bā',
    niveau: 'Abjad',
    ordre: 2,
    formes: [
      { forme: 'بـ', position: 'début', position_ar: 'أول الكلمة' },
      { forme: 'ـبـ', position: 'milieu', position_ar: 'وسط الكلمة' },
      { forme: 'ـب', position: 'fin', position_ar: 'آخر الكلمة' },
      { forme: 'ب', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'يخرج الصوت [ب] من انفجار الشفتين',
    situation_depart: {
      texte: 'يَلْعَبُ التَّلاميذُ في اَلْمَلْعَبِ',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '⚽',
      personnage: 'بَدْرُ'
    },
    mots_exemples: [
      { mot: 'بَطَّةٌ', mot_highlight: '<HL>بَ</HL>طَّةٌ', fr: 'canard', emoji: '🦆', position: 'début' },
      { mot: 'بَيْتٌ', mot_highlight: '<HL>بَ</HL>يْتٌ', fr: 'maison', emoji: '🏠', position: 'début' },
      { mot: 'مَلْعَبٌ', mot_highlight: 'مَلْعَ<HL>بٌ</HL>', fr: 'terrain de jeu', emoji: '🏟️', position: 'fin' },
      { mot: 'بُرْتُقالٌ', mot_highlight: '<HL>بُ</HL>رْتُقالٌ', fr: 'orange', emoji: '🍊', position: 'début' },
      { mot: 'كِتابٌ', mot_highlight: 'كِتا<HL>بٌ</HL>', fr: 'livre', emoji: '📖', position: 'fin' },
    ],
    harakat_courtes: ['بَ', 'بِ', 'بُ'],
    harakat_longues: ['با', 'بو', 'بي'],
    decomposition_syllabique: [
      { mot: 'يَنْبوعٌ', syllabes: ['يَنْ', 'بو', 'عٌ'], nb: 3 },
      { mot: 'بِكْرٌ', syllabes: ['بِكْ', 'رٌ'], nb: 2 },
    ],
    phrases: [
      { ar: 'يَلْعَبُ التَّلاميذُ في اَلْمَلْعَبِ', fr: 'Les élèves jouent sur le terrain', mots_cles: ['بُ', 'بِ'] },
      { ar: 'مَنْزِلُنا مُرَتَّبٌ', fr: 'Notre maison est rangée', mots_cles: ['بٌ'] },
    ],
    exercice_ecriture: { phrase: 'بَيْتٌ', fr: 'maison' },
    prerequis: [],
    note_pedagogique: 'ب = "b" comme en français. Deuxième lettre de l\'alphabet. La paire ب/ت/ث partage la même forme de base avec des points différents (1, 2, 3) — excellent ancrage mémoriel.'
  },

  // ==================== ا / أ (Alif) ====================
  alif: {
    lettre: 'ا',
    nom: 'الأَلِف',
    transliteration: 'Alif',
    niveau: 'Abjad',
    ordre: 1,
    formes: [
      { forme: 'أَ / أِ / أُ', position: 'début avec hamza', position_ar: 'أول الكلمة' },
      { forme: 'ـا', position: 'voyelle longue', position_ar: 'وسط/آخر الكلمة' },
      { forme: 'ا', position: 'isolée', position_ar: 'معزولة' },
    ],
    articulation: 'الأَلِف حرف مدّ — يمتد الصوت [ا] من الحلق بدون عائق',
    situation_depart: {
      texte: 'يَتَوَجَّهُ أَحْمَدُ وَأَمينَةُ إِلى اَلْمَدْرَسَةِ',
      question: 'ما هو الصوت المتكرر؟',
      emoji: '🏫',
      personnage: 'أَحْمَدُ'
    },
    mots_exemples: [
      { mot: 'أَسَدٌ', mot_highlight: '<HL>أَ</HL>سَدٌ', fr: 'lion', emoji: '🦁', position: 'début' },
      { mot: 'بابٌ', mot_highlight: 'ب<HL>ا</HL>بٌ', fr: 'porte', emoji: '🚪', position: 'milieu' },
      { mot: 'كِتابٌ', mot_highlight: 'كِت<HL>ا</HL>بٌ', fr: 'livre', emoji: '📖', position: 'milieu' },
      { mot: 'سَماءٌ', mot_highlight: 'سَم<HL>ا</HL>ءٌ', fr: 'ciel', emoji: '☁️', position: 'milieu' },
      { mot: 'أُمٌّ', mot_highlight: '<HL>أُ</HL>مٌّ', fr: 'maman', emoji: '👩', position: 'début' },
    ],
    harakat_courtes: ['أَ', 'أِ', 'أُ'],
    harakat_longues: ['ـا (voyelle longue)'],
    phrases: [
      { ar: 'أَنَا أُحِبُّ اللُّغَةَ الْعَرَبِيَّةَ', fr: 'J\'aime la langue arabe', mots_cles: ['أَ', 'أُ'] },
    ],
    exercice_ecriture: { phrase: 'أُمٌّ', fr: 'maman' },
    prerequis: [],
    note_pedagogique: 'L\'alif est la première lettre et sert de support à la hamza (أ إ آ) en début de mot. En milieu/fin de mot, c\'est une voyelle longue "ā". Ne se connecte qu\'à droite. Point fondamental à bien expliquer dès le début.'
  },

};

// ==================== STATS FINALES ====================
// Lettres traitées : 28 / 28 — BASE COMPLÈTE
// Fichiers sources : présentations initiales (17) + renforcement (9) + génération (2: alif, ghayn)
// Types de supports identifiés :
//   - Type 1 : Présentation initiale (découverte)
//   - Type 2 : Révision multi-lettres (مراجعة)
//   - Type 3 : Renforcement par paires (دعم وتثبيت)

export default LETTRES_DATA;
